import colors from "@app/styles/_colors.module.scss";

const ReliabilityColor = Object.freeze({
  NOT_RELIABLE: colors.slate,
  RELIABLE: colors.green100,
});

export default ReliabilityColor;
